import { render, staticRenderFns } from "./PharmacyTabs.vue?vue&type=template&id=01cae625&"
import script from "./PharmacyTabs.vue?vue&type=script&lang=js&"
export * from "./PharmacyTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports